import {
    HttpEvent,
    HttpHandlerFn,
    HttpInterceptorFn,
    HttpRequest,
} from "@angular/common/http";
import { inject } from "@angular/core";
import { Auth, idToken } from "@angular/fire/auth";
import { AuthService } from "app/auth/auth.service";
import { from, Observable, switchMap, take } from "rxjs";
import { environment } from "../../environments/environment";

const addBearerToken = (
    req: HttpRequest<any>,
    next: HttpHandlerFn,
): Observable<HttpEvent<any>> => {
    const auth = inject(Auth);
    return from(idToken(auth)).pipe(
        take(1),
        switchMap((token) => {
            if (token) {
                req = req.clone({
                    setHeaders: { Authorization: `Bearer ${token}` },
                });
            }
            return next(req);
        }),
    );
};

export const bearerTokenInterceptor: HttpInterceptorFn = (req, next) => {
    const auth = inject(AuthService);

    // Only add the bearer token to requests t o the backend
    // Customize this to only add the bearer token to specific requests if needed

    // Skip the interceptor for authentication-related URLs
    if (req.url.includes("authentication/providers")) {
        return next(req);
    }

    // Add token for requests to the base URL
    if (req.url.startsWith(environment.baseUrl)) {
        return addBearerToken(req, next);
    }

    // Otherwise, proceed without modifying the request
    return next(req);
};
